import * as React from 'react';
import { useState } from 'react';
import { TableCardModelV2 } from 'shared';
import { Button } from '../../ui/Button';
import { Modal } from '../../ui/Modal';
import { Text } from '../../ui/Text';
import { Card } from '../../ui/Card';
import { token } from '../../ui/theme';

/*
 * LastTrickPeek — a "Last trick" button (lives in the GameInfoPanel) that opens
 * the previous completed trick so a distracted player can see what just
 * happened: the cards played and who won. The captured trick is passed in from
 * setback.tsx (snapshotted when a trick is scored); nothing shows until the
 * first trick of the game completes.
 */

export interface LastTrickData {
  cards: TableCardModelV2[];
  winnerName?: string;
}

interface Props {
  lastTrick?: LastTrickData;
}

const CARD_W = 60;
const CARD_H = 86;

export const LastTrickPeek: React.FC<Props> = ({ lastTrick }) => {
  const [open, setOpen] = useState(false);
  if (!lastTrick || lastTrick.cards.length === 0) return null;

  return (
    <>
      <Button variant="secondary" size="sm" onClick={() => setOpen(true)} style={{ width: '100%' }}>
        Last trick
      </Button>

      <Modal open={open} onClose={() => setOpen(false)} title="Last trick">
        <div style={{ display: 'grid', gap: 'var(--space-4)', justifyItems: 'center' }}>
          <div
            style={{
              display: 'flex',
              gap: 'var(--space-2)',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            {lastTrick.cards.map((c, i) => (
              <Card
                key={`${c.imageUrl}-${i}`}
                code={c.imageUrl}
                width={CARD_W}
                height={CARD_H}
                style={
                  c.isWinner
                    ? {
                        outline: `2px solid ${token('color-gold')}`,
                        outlineOffset: -1,
                        borderRadius: 'var(--radius-sm)',
                      }
                    : undefined
                }
              />
            ))}
          </div>
          <Text variant="muted">
            {lastTrick.winnerName ? `Won by ${lastTrick.winnerName}` : 'Trick complete'}
          </Text>
        </div>
      </Modal>
    </>
  );
};

export default LastTrickPeek;
